import React, {PureComponent} from 'react';
import {isMobile} from 'react-device-detect';
import {withTranslation} from 'react-i18next';
import {Redirect} from "react-router";
import {toast} from "react-toastify";
import Spinner from "../../UI/Spinner";
import axios from "../../../axios-defaults";

import TableContainer from './Table/TableContainer';
import Auxiliary from "../../../hoc/Auxiliary";

import SearchForm from "../../UI/SearchForm/SearchForm";
import UserContext from '../../../context/user-context';
import CardGeneric from "../../Cards/CardGeneric";
import Popup from "reactjs-popup";
import PaymentPopup from "../../UI/PaymentPopup";
import NewAccountForm from "./NewAccountForm";
import LivePagination from "../../UI/LivePagination";
import ModalMxo from "../../UI/Modal";
import {OverlayTrigger, Tooltip} from "react-bootstrap";

class List extends PureComponent {
    static contextType = UserContext;

    constructor(props) {
        super(props);

        this.state = {
            loading: false,
			pagination: {
				pageNumber: 1,
				pageSize: 10,
				totalPages: null,
				totalItems: 0,
			},
            originalAccounts: null,
            accounts: null,
            percentLoaded: 0,
            searchQuery: null,
            redirectToHome: false,
            displayMode: (isMobile?'card':'list'),
			ajaxController: null,
			showModal: false,
			modalAction: null,
			modalTargetId: null,
        }
        window.addEventListener("resize", this.handleResizeChange);
    }

    componentDidMount() {
		this.setState({loading: true});
		this.getListAccounts();
		this.checkForStatusMessage();
    }

	checkForStatusMessage = () => {
		const message = sessionStorage.getItem('status');
		if (message) {
			toast.success(message);
			sessionStorage.removeItem('status');
		}
	};

    handleResizeChange = () => {
        const mobileMatch = window.matchMedia && window.matchMedia("(max-width: 480px)").matches;
        if ((mobileMatch && this.state.displayMode === 'list')
            || (!mobileMatch && this.state.displayMode === 'card')
        ) {
            this.setState({displayMode:(mobileMatch?'card':'list')});
        }
    }

	setPage = (page, triggerFetch = true) => {
		this.setState({
			loading:triggerFetch,
			pagination: {
				...this.state.pagination,
				pageNumber: page
			}
		}, () => {
			if (triggerFetch)
				this.getListAccounts()
		});
	}

	setPerPage = (event) => {
		this.setState({
			loading:true,
			pagination: {
				...this.state.pagination,
				pageNumber: 1,
				pageSize: Number(event.target.value)
			}
		}, () => {
			this.getListAccounts()
		});
	}

	disableTokenModalTrigger = (account_code, token_url) => {

        let accounts = this.state.accounts;
        let originalAccounts = this.state.originalAccounts;

        accounts
            .filter(account => account.accountCode === account_code)
            .map(function(account)
            {
                account.token_url = token_url
                return account
            })
        originalAccounts
            .filter(account => account.accountCode === account_code)
            .map(function(account)
            {
                account.token_url = token_url
                return account
            })

		this.setState({loading: true});
		this.setState({loading: false});
	}

	copyTokenUrlClipboard = (e, token_url) => {
		if (e !== undefined)
			e.preventDefault();

		navigator.clipboard.writeText(token_url);
		toast.info(
			<div>
				<i className="fal fa-exclamation-circle"></i>&nbsp;{this.props.t("misc.copied_to_clipboard")}
			</div>
		);
	}

	setSearchQuery(query) {
		this.setState({
			loading:true,
			searchQuery: query,
			pagination:{
				...this.state.pagination,
				pageNumber: 1
			}
		}, () => {
			this.getListAccounts()
		});
	}

	getListAccounts () {

		const {pagination, searchQuery, ajaxController} = this.state;

		let params = {
			personnification: this.props.personnification,
			search: searchQuery,
			pageNumber:pagination.pageNumber,
			pageSize:pagination.pageSize
		};

		if (ajaxController ) {
			ajaxController.abort();
		}

		let newAjaxController = new AbortController();
		this.setState({
			ajaxController:newAjaxController
		});
		axios.get(`/accounts/linked-accounts`, {params: params, signal:newAjaxController.signal})
			.then(response => {
				if (response.data.succeeded) {
					const accounts = response.data.data.map(account => ({
						...account,
						users: account.users ? account.users.map(user => ({
							...user,
							is_blocked: user.is_blocked || false,
							blocked_at: user.blocked_at || null
						})) : [],
						is_blocked: account.is_blocked || false,
						blocked_at: account.blocked_at || null
					}));
					this.setState({
						ajaxController:null,
						originalAccounts: accounts,
						accounts: accounts,
						loading: false,
						pagination:{
							...this.state.pagination,
							pageNumber: parseInt(response.data.pageNumber),
							totalPages: parseInt(response.data.totalPages),
							pageSize: parseInt(response.data.pageSize),
							totalItems:  parseInt(response.data.totalRecords)
						}
					});
				}
			})
	}

	isAccountSelected = (accountCode) => {
		return this.context.user.account
			&& this.context.user.account.accountCode
			&& this.context.user.account.accountCode === accountCode
	}

	onSearchDataUpdate = (searchData, searchQuery) => {
		if (this.props.personnification)
			return null;

		if (Array.isArray(searchData)) {
			return this.setState({accounts: searchData, searchQuery: searchQuery});
		} else {
			return null;
		}
	}

	selectClickHandler = (account_code) => {
		axios.get(`/switchaccount/` + account_code)
			.then((response) => {
				if (response.data.status === 'success') {
					window.location = '/';
				} else if(response.data.message) {
					toast.error(response.data.message);
				}
			})
			.catch((error) => {

				if (error.response) {
					if (error.response.status === 403) {
						toast.error(this.props.t('auth.account_blocked'));
					} else {
						toast.error(error.response.data.message);
					}
				} else {
					toast.error(this.props.t('errors.unexpected'));
				}
			});
	};

	selectUserClickHandler = (user_id) => {
		/*toast.success(
			<div>
				<i className="fal fa-exclamation-circle"></i>&nbsp;{this.props.t('linkedaccounts.switch_usersuccess', {account_code: account_code})}
			</div>
		);*/
		window.location = "/switchuser/"+user_id;
	};

	handleShowModal = (action, targetId) => {
		this.setState({
			showModal: true,
			modalAction: action,
			modalTargetId: targetId,
		});
	};

	handleCloseModal = () => {
		this.setState({
			showModal: false,
			modalAction: null,
			modalTargetId: null,
		});
	};

	handleConfirmModalAction = () => {
		const { modalAction, modalTargetId } = this.state;

		if (modalAction === 'blockUser') {
			this.blockUser(modalTargetId);
		} else if (modalAction === 'unblockUser') {
			this.unblockUser(modalTargetId);
		} else if (modalAction === 'blockAccount') {
			this.blockAccount(modalTargetId);
		} else if (modalAction === 'unblockAccount') {
			this.unblockAccount(modalTargetId);
		}

		this.handleCloseModal();
	};

	blockUser = (user_id) => {
		axios.post(`/users/${user_id}/block`)
			.then(response => {
				toast.success(this.props.t('linkedaccounts.user_blocked_success'));
				this.setState(prevState => {
					const updateBlockedStatus = (account) => {
						return {
							...account,
							users: account.users.map(user =>
								user.id === user_id ? { ...user, is_blocked: true } : user
							)
						};
					};

					return {
						accounts: prevState.accounts.map(updateBlockedStatus),
						originalAccounts: prevState.originalAccounts.map(updateBlockedStatus)
					};
				});
			})
			.catch(error => {
				toast.error(this.props.t('errors.error'));
			});
	}

	unblockUser = (user_id) => {
		axios.post(`/users/${user_id}/unblock`)
			.then(response => {
				toast.success(this.props.t('linkedaccounts.user_unblocked_success'));
				this.setState(prevState => {
					const updateBlockedStatus = (account) => {
						return {
							...account,
							users: account.users.map(user =>
								user.id === user_id ? { ...user, is_blocked: false } : user
							)
						};
					};

					return {
						accounts: prevState.accounts.map(updateBlockedStatus),
						originalAccounts: prevState.originalAccounts.map(updateBlockedStatus)
					};
				});
			})
			.catch(error => {
				toast.error(this.props.t('errors.error'));
			});
	}

	blockAccount = (accountCode) => {
		axios.post(`/accounts/${accountCode}/block`)
			.then(response => {
				toast.success(this.props.t('linkedaccounts.account_blocked_success'));

				this.setState(prevState => {
					const updateBlockedStatus = (account) => {
						return account.accountCode === accountCode
							? { ...account, is_blocked: true }
							: account;
					};

					return {
						accounts: prevState.accounts.map(updateBlockedStatus),
						originalAccounts: prevState.originalAccounts.map(updateBlockedStatus)
					};
				});
			})
			.catch(error => {
				toast.error(this.props.t('errors.error'));
			});
	}

	unblockAccount = (accountCode) => {
		axios.post(`/accounts/${accountCode}/unblock`)
			.then(response => {
				toast.success(this.props.t('linkedaccounts.account_unblocked_success'));

				this.setState(prevState => {
					const updateBlockedStatus = (account) => {
						return account.accountCode === accountCode
							? { ...account, is_blocked: false }
							: account;
					};

					return {
						accounts: prevState.accounts.map(updateBlockedStatus),
						originalAccounts: prevState.originalAccounts.map(updateBlockedStatus)
					};
				});
			})
			.catch(error => {
				toast.error(this.props.t('errors.error'));
			});
	}

	isAccountBlocked = (user, accountNumber) => {
		const account = user.accounts.find(acc => acc.number == accountNumber);
		return account ? (account.is_blocked === 1 || account.is_blocked === true) : false;
	};

	btnUnassignOwnerModal = (userId,accountCode,userCount) => {
		return (
			<Popup trigger={<a href="#" className="link link--red link--accent link--fs-14">{this.props.t('linkedaccounts.table.row.unassign')}</a>} modal>
				{close => (

					<div className="popup-delete">
						{userCount === 1 ?
							<div className="content">{this.props.t("linkedaccounts.table.row.confirm_unassign.text")}</div> :
							<div className="content">{this.props.t("linkedaccounts.table.row.confirm_unassign.text_refused")}</div>
						}

						<div className="actions">
							<button
								className="btn btn-primary btn-sm"
								onClick={() => {
									close();
								}}
							>{this.props.t('linkedaccounts.table.row.confirm_unassign.cancel')}</button>
							{userCount === 1 ?
								<button
									className="btn btn-secondary btn-sm"
									onClick={() => {
										axios.put(`/accounts/unassign-owners`, {
											userIds: [userId],
											accountCodes: [accountCode]
										})
											.then(response => {
												if (response.data.succeeded) {
													// TODO: Need to remove the user. But how?
													// let newItems = items.filter(item => item.id !== userId)
													// setFilteredItems(newItems);
													// setItems(newItems);
													close();
													window.location.reload(false);
												}
											})
											.catch(error => {
												console.log('[List.js] : UnassignOwner ajax error in btnUnassignOwnerModal()', error.message);
												close();
											})
									}}
								>{this.props.t('linkedaccounts.table.row.unassign')}</button> :
								null
							}
						</div>
					</div>
				)}
			</Popup>
		);
	};

	render() {
		const {
			originalAccounts,
			accounts,
			redirectToHome,
			loading,
			displayMode,
			searchQuery,
			pagination
		} = this.state;
		const {user} = this.context;
		const {t, personnification} = this.props;
		const { showModal, modalAction } = this.state;
		let canBlock = this.context.user && this.context.user.infos ? this.context.user.infos.can_block : false;
		if (redirectToHome) {
			return <Redirect to={{pathname: "/"}}/>;
		}

		const columns = [
			{
				Header: t('linkedaccounts.table.header.client'),
				accessor: 'name',
				Cell: (props) => {
					let html = '';

					if (props.row.original.subAccountSites && props.row.original.subAccountSites.length > 0) {
						let siteCodes = props.row.original.subAccountSites.map(function (subAccountSite) {
							return subAccountSite.siteName;
						})

						if (props.row.original.subAccountSites.length > 4) {
							html = (
								<Auxiliary>
									<p>{props.value ? <strong>{props.value}</strong> : ''}</p>
									<PaymentPopup
										btn_title={t('View sites')}
										modal_title={t("Account Sites")}
										modal_content={
											props.row.original.subAccountSites.map(item => <div>{item.siteName} : {item.siteCode}</div>)
										}
									/>
								</Auxiliary>
							);
						}
						else{
							html = (
								<Auxiliary>
									<p>{props.value ? <strong>{props.value}</strong> : ''}</p>
									<p>{props.row.original.subAccountSites.map(item => <span>{item.siteCode}</span>)
										.reduce((result, item) => [result, <span>, </span>, item])}</p>
								</Auxiliary>)
						}
					}
					else{
						html = props.value ? <strong>{props.value}</strong> : '';
					}

					return html;
				},
			},
			{
				Header: t('linkedaccounts.table.header.account_code'),
				accessor: 'accountCode',
				Cell: (props) => {
					const { accountCode, users } = props.row.original;

					let userIsOwner = users.some(user => user.isAccountOwner);
					let isBlocked = props.row.original.is_blocked;
					const blocked_at = props.row.original.blocked_at ? new Date(props.row.original.blocked_at).toLocaleString() : null;
					const loggedInUser = this.context.user;
					let canPersonify = loggedInUser && loggedInUser.infos ? loggedInUser.infos.can_personify : false;
					let isPersonnificationPage = window.location.pathname === "/personnification";

					let html = (
						<Auxiliary>
							{(props.value) ? <div> {isBlocked ? <i className="fas fa-lock"></i> : ''} {props.value}</div> : ''}
							{canBlock && isPersonnificationPage  && props.value !== null &&
								<div>
									{isBlocked ? (
										<>
											<a href="#"
											   className='link link--red link--accent link--fs-14 strong--weight--bold btn--nowrap'
											   onClick={(e) => {
												   e.preventDefault();
												   this.handleShowModal('unblockAccount', accountCode);
											   }}
											>
												{t('linkedaccounts.table.row.unblock_account')}
												&nbsp;
												<OverlayTrigger
													placement="top"
													overlay={<Tooltip id="tooltip-top">{`${t('linkedaccounts.table.row.blocked_date')} ${blocked_at}`}</Tooltip>}
												>
													<i className="fas fa-info-circle"></i>
												</OverlayTrigger>
											</a>


										</>

									) : (
										<a href="#" className='link link--red link--accent link--fs-14 btn--nowrap'
										   onClick={(e) => {
											   e.preventDefault();
											   this.handleShowModal('blockAccount', accountCode);
										   }}
										>
											{t('linkedaccounts.table.row.block_account')}
										</a>
									)}
								</div>
							}
						</Auxiliary>
					);

					return html;
				}
			},
			{
				Header: t('linkedaccounts.table.header.address'),
				accessor: 'address',
				Cell: (props) => {
					let html = props.value ? (
						<Auxiliary>
							{props.value.addressLine1 ? <Auxiliary>{props.value.addressLine1}<br/></Auxiliary> : ''}
							{props.value.addressLine2 ? <Auxiliary>{props.value.addressLine2}<br/></Auxiliary> : ''}
							{props.value.city ? <Auxiliary>{props.value.city}<br/></Auxiliary> : ''}
							{props.value.postalCode ? props.value.postalCode +', ' : '' }{props.value.stateOrProvinceCode ? props.value.stateOrProvinceCode : ''}
						</Auxiliary>
					) : '';
					return html;
				}
			},
			{
				Header: (props) => {
					return (props.rows[0].original.token_url === undefined) ?
						null :
						t('linkedaccounts.table.header.user')
				} ,
				accessor: 'users',
				Cell: (props) => {
                    let html = props.value.length > 0 ? (props.value.map((item, index) => {
							const blocked_at = item.blocked_at ? new Date(item.blocked_at).toLocaleString() : null;
							return (
								<div key={item.id}>
									<strong>{item.is_blocked ? <i className="fas fa-lock"></i> : ''} {item.name}{(item.isAccountOwner)?" ("+t("profile.assignments.list.role.owner")+")":""}</strong><br/>
									{item.email}<br/>
									<div className="d-flex justify-content-between flex-wrap">
										<a href="#" className="link link--red link--accent link--fs-14" onClick={() => {
											this.selectUserClickHandler(item.id);
										}}>{t('linkedaccounts.table.row.personify')}</a>
										<>

											{canBlock && (item.is_blocked ? (
												<a href="#" className='link link--red link--accent link--fs-14 strong--weight--bold btn--nowrap'
												   onClick={(e) => {
													   e.preventDefault();
													   this.handleShowModal('unblockUser', item.id);
												   }}
												>
													{t('linkedaccounts.table.row.unblock_user')}
													{blocked_at && (
														<>
															&nbsp;
															<OverlayTrigger
																placement="top"
																overlay={<Tooltip id="tooltip-top">{`${t('linkedaccounts.table.row.blocked_date')} ${blocked_at}`}</Tooltip>}
															>
																<i className="fas fa-info-circle"></i>
															</OverlayTrigger>
														</>
													)}

												</a>
											) : (
												<a href="#" className='link link--red link--accent link--fs-14 btn--nowrap'
												   onClick={(e) => {
													   e.preventDefault();
													   this.handleShowModal('blockUser', item.id);
												   }}
												>
													{t('linkedaccounts.table.row.block_user')}
												</a>
											))}
										</>
										{item.isAccountOwner ?
											this.btnUnassignOwnerModal(item.id, props.row.original.accountCode, props.value.length) :
											null
										}
									</div>

								</div>
							)
						})):
						(props.row.original.token_url !== undefined) ?
							(props.row.original.token_url === '') ?
								<div>
									<PaymentPopup
										btn_title={t('linkedaccounts.table.row.generate_token')}
										btn_type={'link'}
										modal_title={t("popup.generate_token.title")}
										modal_content={
											<div>
												<NewAccountForm
													account_code={props.row.values.accountCode}
													closePopup={() => {$('.modal-header .close').click()}}
													onSuccess={this.disableTokenModalTrigger}
												/>
											</div>
										}
									/>
								</div>
								:
								<div>
									<a onClick={(e) => this.copyTokenUrlClipboard(e, props.row.original.token_url)}
									   className={'link link--red link--accent link--fs-14'}>
										{this.props.t("popup.generate_token.copy_to_clipboard")}
									</a>
								</div>
							: null
					return html;
				}
			},
			{
				Header: () => null,
				id: 'select',
				accessor: 'accountCode',
				Cell: (props) => {

					if (props.value) {
						return (
							<Auxiliary>
								{this.isAccountSelected(props.value)?(<i>{t('linkedaccounts.table.row.selected')}</i>):(<button className='btn btn--raised--red btn--raised' onClick={(v) => {
									this.selectClickHandler(props.value);
								}}>{t('linkedaccounts.table.row.select')}</button>)}

							</Auxiliary>
						);
					} else {
						return '';
					}
				}
			}];

		let dataHtml = '';
		let headerHtml = '';
		let searchHtml = '';
		let modalHtml = '';

		searchHtml = (
			<div className='section__action section__action--comms'>
				<div className="container-fluid">
					<SearchForm data={originalAccounts} currentData={accounts} updateData={this.onSearchDataUpdate}
								setSearchQuery={(value) => {this.setSearchQuery(value)}}
								placeholder={'linkedaccounts.search_placeholder'}
								personnification={this.props.personnification} />
				</div>

			</div>
		);

		modalHtml = (
			<ModalMxo
				show={showModal}
				onHide={this.handleCloseModal}
				title={
					modalAction?.includes('unblock')
						? t('linkedaccounts.confirm_unblock')
						: t('linkedaccounts.confirm_block')
				}
				showCloseButton={false}
				footerActions={
					<div className="modal-footer d-flex justify-content-end">
						<button
							className="btn btn--raised btn--raised--gray"
							onClick={this.handleCloseModal}
						>
							{t('account.cards.management.buttons.cancel')}
						</button>
						<button
							className="btn btn--raised btn--raised--red ml-2"
							onClick={this.handleConfirmModalAction}
						>
							{t('account.cards.management.buttons.confirm')}
						</button>
					</div>
				}
			>
				{t('linkedaccounts.proceed_action')}
			</ModalMxo>
		);

		if (loading) {
			dataHtml = (
				<div className="container-fluid">
					<Spinner />
				</div>
			);
		} else {
			if (Array.isArray(accounts) && accounts.length > 0) {
				headerHtml = (
					<Auxiliary>
						<br />
						<h3 className="headline headline--block">{
							(searchQuery?
								t('linkedaccounts.search_result', {count:pagination.totalItems, searched_term: searchQuery}):
								t('linkedaccounts.nosearch', {count: pagination.totalItems}))

						}</h3>
					</Auxiliary>
				)
				if (displayMode === 'list') {
					dataHtml = (
						<Auxiliary>
							<TableContainer
								columns={columns}
								data={accounts}
							/>

							<LivePagination
								paginationData={pagination}
								setPage={this.setPage}
								setPerPage={this.setPerPage}
								pageInputHandler={this.pageInputHandler}
							/>
						</Auxiliary>
					);
				} else if (displayMode === 'card') {
					const totalCurrentItems = (accounts) ? accounts.length : 0;
					dataHtml = (
						<Auxiliary>
							<div className="row">
								{accounts.map((item, index) => {
									return (
										<div className="col-12 col-sm-6 col-md-4 mb-4" key={index}>
											<CardGeneric title={""} additionalClasses={["link-account"]}>
												<>
													<p>
														<strong>{t('linkedaccounts.table.header.client')}</strong>
														<br />
														{item.name}
													</p>
													{item.address &&
														<p>
															<strong>{t('linkedaccounts.table.header.address')}</strong>
															<br />
															{item.address.addressLine1 ? <Auxiliary>{item.address.addressLine1}<br/></Auxiliary> : ''}
															{item.address.addressLine2 ? <Auxiliary>{item.address.addressLine2}<br/></Auxiliary> : ''}
															{item.address.city ? <Auxiliary>{item.address.city}<br/></Auxiliary> : ''}
															{item.address.postalCode ? item.address.postalCode +', ' : '' }{item.address.stateOrProvinceCode ? item.address.stateOrProvinceCode : ''}
														</p> }

													<p>
														<strong>{t('linkedaccounts.table.header.account_code')}</strong>
														<br />
														{item.accountCode}
													</p>

													{
														(Array.isArray(item.users) && item.users.length) ?  <p>
															<strong>{t('linkedaccounts.table.header.user')}</strong>
															<div className='box-users'>
																{(item.users.map((item, index) => { return (
																	<div key={item.id}>
																		<strong>{item.name}{(item.isAccountOwner)?" ("+t("profile.assignments.list.role.owner")+")":""}</strong><br/>
																		{item.email}<br/>
																		<a href="#" className="link link--red link--accent link--fs-14" onClick={() => {
																			this.selectUserClickHandler(item.id);
																		}}>{t('linkedaccounts.table.row.personify')}</a>
																	</div>
																)})) }</div></p> : ''
													}

													<p>
														{this.isAccountSelected(item.accountCode)?(<i>{t('linkedaccounts.table.row.selected')}</i>):(<button className='btn btn--raised--red btn--raised' onClick={(v) => {
															this.selectClickHandler(item.accountCode);
														}}>{t('linkedaccounts.table.row.select')}</button>)}
													</p>
												</>
											</CardGeneric>
										</div>
									);
								})}
							</div>

							<LivePagination
								paginationData={pagination}
								setPage={this.setPage}
								setPerPage={this.setPerPage}
								pageInputHandler={this.pageInputHandler}
							/>


						</Auxiliary>
					);
				}
			} else {
				if (personnification && (searchQuery == null || searchQuery.lenght < 3)){
					dataHtml = (<p><strong>{t('linkedaccounts.miin_three_characters_search')}</strong></p>);
				}
				else if (personnification){
					dataHtml = (<p><strong>{t('linkedaccounts.noresults')}</strong></p>);
				}
				else{
					dataHtml = (<p><strong>{t('linkedaccounts.noresults')}</strong></p>);
				}
			}
		}

		return (
			<div className="linked-account">
				{searchHtml}
				{headerHtml}
				{dataHtml}
				{modalHtml}
			</div>
		);

	}
}

export default withTranslation()(List);
